import React from 'react';
import PropTypes from 'prop-types';
import { AdTag, Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';

import { enhancedConnect } from 'utils/lowCodeHelpers';

import styles from './styles.pcss';
import { IAddBadge } from '../../../PromoPageLCP/types';

const cx = classNames.bind(styles);

interface ContentBlockProps {
  badge: IAddBadge;
  content: string;
  imgSrc: string;
  title: string;
}
const _ContentBlock: React.FC<ContentBlockProps> = ({ title, content, imgSrc, badge }) => {
  return (
    <div className={cx('wrapper')}>
      {imgSrc && (
        <div className={cx('image-wrapper')}>
          <img alt={title} className={cx('image')} src={imgSrc} />
          {badge && (
            <AdTag
              className={cx('ad')}
              invert={badge.invert}
              label={badge.text}
              popoverProps={{
                closureModes: {
                  scroll: true,
                },
              }}
              size="l"
              tooltipDirection={badge.direction}
            >
              {badge.tooltipText}
            </AdTag>
          )}
        </div>
      )}
      <Text
        className={cx('content')}
        /* для обратной совместимости, есть кастомная локальная верстка */
        dangerouslySetInnerHTML={{
          __html: content,
        }}
        tagName="div"
      />
    </div>
  );
};

export const ContentBlock = enhancedConnect({
  content: PropTypes.string,
  title: PropTypes.string,
  badge: PropTypes.string,
  imgSrc: PropTypes.string,
})(_ContentBlock);
